<template>
  <section class="static-banner">
    <div class="static-banner-content">
      <div class="container">
        <h1
          class="static-banner-title"
          v-html="$route.meta.title"
        >
        </h1>
      </div>
    </div>

    <div
      v-parallax="0.3"
      class="static-banner-bg"
      :style="{ backgroundImage: 'url(' + require('@/assets/img/'+ $route.meta.banner) + ')' }"
    >
    </div>
  </section>
</template>

<script>
  export default {
    name: "PageBanner"
  };
</script>